import {
  Box,
  Button,
  List,
  TogglerCheckbox,
  useToggle,
} from '@factorialco/deprecated-design-system'

import ConfigureIncidence from './ConfigureIncidence'

export interface ItemProps {
  title: string
  description: string
  disabled: boolean
  onTogglerChange: () => void
  active: boolean
  onSetValidation: () => void
  needsValidation?: boolean
  isSettings: boolean
}

const Item = ({
  title,
  description,
  disabled,
  onTogglerChange,
  active,
  onSetValidation,
  needsValidation = false,
  isSettings,
}: ItemProps) => {
  const [open, toggleModal] = useToggle(false)

  return (
    <List.Item>
      <Box
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        width="full"
        background="grey000White"
      >
        <Box flexDirection="column">
          <List.Title>{title}</List.Title>
          <List.Description>{description}</List.Description>
        </Box>
        <Box alignItems="flexEnd" justifyContent="spaceBetween" flexDirection="row" gap="s8">
          <Box alignSelf="center">
            <TogglerCheckbox
              value={active}
              onChange={() => onTogglerChange()}
              disabled={disabled}
            />
          </Box>
          {!isSettings && (
            <Button
              type="secondary"
              disabled={!active}
              onClick={toggleModal(true)}
              iconName="settings"
            />
          )}
        </Box>
      </Box>
      {open && (
        <ConfigureIncidence
          onClose={toggleModal(false)}
          onSubmit={onSetValidation}
          title={title}
          needsValidation={needsValidation}
        />
      )}
    </List.Item>
  )
}

export default Item
